import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getShift } from 'lib/selectors/getShift';

const getShiftName = createSelector([getShift], (shift) => {
  return _get(shift, 'name');
});

export { getShiftName };
